(function() {
    'use strict';

    let currentVideoIndex = 0;
    let allVideoSlides = [];

    function initializeVideoSlider() {
        console.log('🎥 Collection Video Grid - Initializing...');

        const sliderContainer = document.querySelector('.collection-video-slider');
        
        if (!sliderContainer) {
            console.warn('❌ Slider container not found');
            return;
        }

        // Wait for Swiper to be available
        if (!window.Swiper) {
            console.warn('⏳ Swiper not loaded, retrying...');
            setTimeout(initializeVideoSlider, 500);
            return;
        }

        // Initialize Swiper
        let swiper = sliderContainer.swiper;
        
        if (!swiper) {
            console.log('🔄 Creating new Swiper instance...');
            swiper = new Swiper(sliderContainer, {
                slidesPerView: 'auto',
                spaceBetween: 12,
                loop: false,
                navigation: {
                    nextEl: sliderContainer.querySelector('.swiper-button-next'),
                    prevEl: sliderContainer.querySelector('.swiper-button-prev'),
                },
                watchOverflow: true,
            });
        }

        // Function to load video into container
        function loadVideoIntoSlide(slide) {
            if (!slide) return;

            const container = slide.querySelector('.iframe-container');
            if (!container) {
                console.warn('⚠️ No iframe-container found in slide');
                return;
            }

            // Don't reload if already loaded
            if (container.dataset.loaded === 'true' || container.querySelector('iframe')) {
                return;
            }

            const videoUrl = slide.dataset.videoUrl;
            const productTitle = slide.dataset.productTitle || 'Product Video';

            if (!videoUrl) {
                console.warn('⚠️ No video URL in slide:', slide);
                container.innerHTML = '<p style="padding: 20px; text-align: center; color: #999;">No video available</p>';
                container.dataset.loaded = 'true';
                return;
            }

            console.log('✅ Loading video:', videoUrl);

            // Create and inject iframe
            const iframe = document.createElement('iframe');
            iframe.src = videoUrl + '?background=%23000000&autoplay=true&loop=true&mute=true&tr=w-400&controls=false';
            iframe.width = '100%';
            iframe.height = '482';
            iframe.frameBorder = '0';
            iframe.allowFullscreen = true;
            iframe.allow = 'autoplay; fullscreen';
            iframe.title = productTitle;
            iframe.style.cssText = 'display: block; border: none;';

            // Clear container and add iframe
            container.innerHTML = '';
            container.appendChild(iframe);
            container.dataset.loaded = 'true';
        }

        // Load ALL videos immediately (Option 1)
        function loadAllVideos() {
            const slides = swiper.slides;
            console.log('📹 Loading all', slides.length, 'videos...');
            
            slides.forEach((slide, index) => {
                setTimeout(() => {
                    loadVideoIntoSlide(slide);
                }, index * 100); // Stagger loading to avoid overload
            });
        }

        // Alternative: Load current + next 3 slides (Option 2)
        function loadAdjacentVideosExtended() {
            const activeIndex = swiper.activeIndex;
            const slides = swiper.slides;

            // Load current + next 3 slides
            for (let i = 0; i <= 3; i++) {
                if (slides[activeIndex + i]) {
                    loadVideoIntoSlide(slides[activeIndex + i]);
                }
            }

            // Load previous slide
            if (slides[activeIndex - 1]) {
                loadVideoIntoSlide(slides[activeIndex - 1]);
            }
        }

        // Using Option 1 - Load ALL
        setTimeout(loadAllVideos, 100);

        // Load on slide change
        swiper.on('slideChange', function() {
            console.log('📍 Slide changed to:', swiper.activeIndex);
            loadAdjacentVideosExtended();
        });

        // ============================================
        // 🎬 VIDEO POPUP FUNCTIONALITY - NEW
        // ============================================
        
        const videoPopup = document.getElementById('video-popup');
        const popupIframe = document.getElementById('popup-iframe');
        const videoCloseBtn = document.getElementById('video-close');
        const videoPrevBtn = document.getElementById('video-prev');
        const videoNextBtn = document.getElementById('video-next');

        // Get all video slides for popup navigation
        function updateVideoSlidesArray() {
            allVideoSlides = Array.from(document.querySelectorAll('.product-video-card[data-video-url]'));
            console.log('📊 Total videos in popup:', allVideoSlides.length);
        }

        updateVideoSlidesArray();

        // Open popup with specific video
        function openVideoPopup(videoSlide, index) {
            if (!videoPopup) {
                console.warn('❌ Popup element not found');
                return;
            }

            const videoUrl = videoSlide.dataset.videoUrl;
            const productTitle = videoSlide.dataset.productTitle || 'Product Video';

            if (!videoUrl) {
                console.warn('⚠️ No video URL found');
                return;
            }

            console.log('🎬 Opening popup with video:', productTitle);

            // Set current index
            currentVideoIndex = index;

            // Load video in popup iframe with CONTROLS ON
            // autoplay=true: Video auto-play hota hai
            // loop=true: Video loop mein chalti hai
            // mute=false: Audio ON rahti hai
            // controls=true: Play/Pause/Volume/Fullscreen buttons dikhte hain
            const iframeUrl = videoUrl + '?autoplay=true&loop=true&mute=false&controls=true&tr=w-400&modestbranding=false';
            popupIframe.src = iframeUrl;
            popupIframe.title = productTitle;

            // Show popup
            videoPopup.classList.add('active');
            videoPopup.style.display = 'flex';
            document.body.style.overflow = 'hidden'; // Prevent scrolling

            // Update button states
            updatePopupButtonStates();
        }

        // Close popup
        function closeVideoPopup() {
            if (videoPopup) {
                videoPopup.classList.remove('active');
                videoPopup.style.display = 'none';
                popupIframe.src = ''; // Clear iframe
                document.body.style.overflow = ''; // Restore scrolling
                console.log('❌ Popup closed');
            }
        }

        // Navigate to next video in popup
        function nextVideoInPopup() {
            if (currentVideoIndex < allVideoSlides.length - 1) {
                currentVideoIndex++;
                openVideoPopup(allVideoSlides[currentVideoIndex], currentVideoIndex);
                console.log('➡️ Next video:', currentVideoIndex + 1, 'of', allVideoSlides.length);
            } else {
                console.log('ℹ️ Already at last video');
            }
        }

        // Navigate to previous video in popup
        function prevVideoInPopup() {
            if (currentVideoIndex > 0) {
                currentVideoIndex--;
                openVideoPopup(allVideoSlides[currentVideoIndex], currentVideoIndex);
                console.log('⬅️ Previous video:', currentVideoIndex + 1, 'of', allVideoSlides.length);
            } else {
                console.log('ℹ️ Already at first video');
            }
        }

        // Update button states (disable if first/last)
        function updatePopupButtonStates() {
            if (videoPrevBtn) {
                videoPrevBtn.disabled = currentVideoIndex === 0;
                videoPrevBtn.style.opacity = currentVideoIndex === 0 ? '0.5' : '1';
            }
            if (videoNextBtn) {
                videoNextBtn.disabled = currentVideoIndex === allVideoSlides.length - 1;
                videoNextBtn.style.opacity = currentVideoIndex === allVideoSlides.length - 1 ? '0.5' : '1';
            }
        }

        // Add click listeners to all video cards
        function attachVideoCardClickListeners() {
            allVideoSlides.forEach((videoSlide, index) => {
                videoSlide.style.cursor = 'pointer';
                
                videoSlide.addEventListener('click', function(e) {
                    // Don't open popup if clicking on the "View" link
                    if (e.target.tagName === 'A') {
                        return;
                    }
                    
                    console.log('🖱️ Video card clicked:', videoSlide.dataset.productTitle);
                    openVideoPopup(videoSlide, index);
                });
            });
            console.log('✅ Click listeners attached to', allVideoSlides.length, 'videos');
        }

        attachVideoCardClickListeners();

        // Popup button event listeners
        if (videoCloseBtn) {
            videoCloseBtn.addEventListener('click', closeVideoPopup);
        }

        if (videoPrevBtn) {
            videoPrevBtn.addEventListener('click', prevVideoInPopup);
        }

        if (videoNextBtn) {
            videoNextBtn.addEventListener('click', nextVideoInPopup);
        }

        // Close popup on background click
        if (videoPopup) {
            videoPopup.addEventListener('click', function(e) {
                if (e.target === videoPopup) {
                    closeVideoPopup();
                }
            });
        }

        // Close popup on Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && videoPopup && videoPopup.style.display === 'flex') {
                closeVideoPopup();
            }
        });

        console.log('✅ Video slider initialized successfully!');
        console.log('📊 Total slides:', swiper.slides.length);
    }

    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeVideoSlider);
    } else {
        initializeVideoSlider();
    }
})();



